import { Component, computed, inject } from '@angular/core';
import { WizardShellComponentService } from 'app/ai/services/wizard-shell-component.service';
import { AuthService } from 'app/core/services/auth/auth.service';
import { UserService } from 'app/core/services/user/user.service';

@Component({
  selector: 'casa-doc-header',
  standalone: true,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  authService = inject(AuthService);
  userService = inject(UserService);
  wizardShellComponentService = inject(WizardShellComponentService);

  wizardStep = computed(() => {
    if (!this.wizardShellComponentService.isActive()) {
      return null;
    }

    return this.wizardShellComponentService.currentStep();
  });

  userDisplayName = computed(() => {
    const user = this.userService.user;
    if (!user) {
      return '';
    }

    const fullName = [user.name, user.surname].filter(Boolean).join(' ');
    return fullName || user.name || user.username || user.email;
  });

  onSignOut() {
    this.authService.signOut();
  }
}
